import { DrawerMenu } from 'remote/global';
import { Outlet } from 'react-router-dom';
import { useSubscription } from 'react-stomp-hooks';
import { useUsersCurrentAccessesQuery } from 'api/queries/users';
import useMenuItems from 'utils/hooks/useMenuItems';
import { useUIDrawer } from 'api/queries/ui';
import { operatorsQueryKeys, useOperatorsAlertsCountNewQuery } from 'api/queries/operators';
import { useQueryClient } from '@tanstack/react-query';
import { AlertCount } from 'utils/data/data-types';

function LoggedInContainer() {
  const { data: userInfo } = useUsersCurrentAccessesQuery();
  const { operatorId } = userInfo ?? {};
  const { isMobileDrawerOpen, setIsMobileDrawerOpen } = useUIDrawer();
  const queryClient = useQueryClient();
  const { data: alertCount } = useOperatorsAlertsCountNewQuery();
  const menuItems = useMenuItems({ alertCount });

  useSubscription(`/topic/alert-count/operator/${operatorId}`, (message) => {
    const parsedAlert: AlertCount = JSON.parse(message.body);
    if (parsedAlert != null) {
      queryClient.setQueryData(
        operatorsQueryKeys.operatorsAlertsCount(operatorId!),
        parsedAlert.count
      );
    }
  });

  useSubscription(`/topic/alert-created/operator/${operatorId}`, () => {
    // Just invalidate alerts, this needs rework on actual subscription changes
    queryClient.invalidateQueries({ queryKey: operatorsQueryKeys.operatorsAlerts(operatorId!) });
  });

  return (
    <DrawerMenu
      env={window.MOBIFER_ENV}
      isMobileDrawerOpen={isMobileDrawerOpen}
      menuItems={menuItems}
      setIsMobileDrawerOpen={setIsMobileDrawerOpen}
    >
      <Outlet />
    </DrawerMenu>
  );
}

export default LoggedInContainer;
